import { useState } from "react";
import type {
  SendAuthenticationEmailMutation,
  SendAuthenticationEmailMutationVariables,
} from "@generated/graphql";
import { recaptchaActionNames } from "@recaptcha/config/actionNames";
import useHandleRecaptcha from "@recaptcha/useHandleRecaptchaV3";
import { SEND_AUTHENTICATION_EMAIL_MUTATION } from "clientState/operations/mutations";
import { useMutation } from "@edreamsodigeo/frontend-api-client";

import type {
  SendAuthenticationEmailType,
  UseSendAuthenticationEmailType,
} from "./contract";

export const useSendAuthenticationEmail: UseSendAuthenticationEmailType =
  () => {
    const [loading, setLoading] = useState(false);
    const { SIGNUP } = recaptchaActionNames;

    const handleRecaptcha = useHandleRecaptcha(SIGNUP);

    const { mutate } = useMutation<
      SendAuthenticationEmailMutation,
      SendAuthenticationEmailMutationVariables
    >(SEND_AUTHENTICATION_EMAIL_MUTATION);

    const sendAuthenticationEmail: SendAuthenticationEmailType = async ({
      email,
      landingPagePath,
      newsletterSubscribed,
      onSuccess,
      onError,
    }) => {
      setLoading(true);
      await handleRecaptcha();
      mutate(
        { request: { email, landingPagePath, newsletterSubscribed } },
        {
          onSuccess: ({ data, variables }) => {
            setLoading(false);
            onSuccess({
              email: variables.request.email,
              ...data.sendAuthenticationEmail,
            });
          },
          onError: () => {
            setLoading(false);
            onError();
          },
        },
      );
    };

    return {
      sendAuthenticationEmail,
      loading,
    };
  };
